import React from "react";
import { Box } from "@sparrowengg/twigs-react";
import Navbar from "commons/components/navbar";
import EditApp from "features/apps/edit-app/components";

const EditAppPage = () => {
  return (
    <Box css={{ height: "100vh", width: "100vw", overflow:"hidden" }}>
      <Navbar showPreviousBtn />
      <EditApp />
    </Box>
  );
};

export default EditAppPage;
